import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FileImportPayload, FileItemResponse, FileUploadItem } from '../interfaces/files.interface';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  public apiUrl = '';
  protected folderId = '';

  constructor(protected httpClient: HttpClient, protected env: EnvService) {
    this.apiUrl = this.env.environment.directus_url;
    this.folderId = this.env.environment.directus_files_folder_id;
  }

  getResourceUrl(): string {
    return 'files';
  }

  importFileFromUrl(fileUrl: string): Observable<FileItemResponse> {
    const url = `${this.apiUrl}${this.getResourceUrl}/import`;

    const data: FileImportPayload = {
      url: fileUrl,
      data: {
        folder: this.folderId,
      },
    };

    return this.httpClient
      .post(url, data, {
        responseType: 'json',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      })
      .pipe(map((json: any) => json as FileItemResponse));
  }

  uploadFiles(fileUploadItems: FileUploadItem[]): Observable<FileItemResponse> {
    const url = `${this.apiUrl}${this.getResourceUrl()}`;

    const formData = new FormData();

    fileUploadItems.forEach(({ file, additionalData }) => {
      formData.append('folder', this.folderId);
      formData.append('file', file);
      if (additionalData) {
        Object.entries(additionalData).forEach(([key, value]) => {
          formData.append(key, value);
        });
      }
    });

    return this.httpClient.post(url, formData).pipe(map((json: any) => json as FileItemResponse));
  }
}
